<template>
  <ui-menu
    v-model="menu"
    :location="location"
    :offset="offset"
    class="navbar-workspace"
    :content-class="contentClass + ' ' + 'main-menu-workspace'"
    :close-on-content-click="false"
    :eager="true"
  >
    <template #activator="{ props }">
      <slot name="activator" v-bind="{ props }" :value="menu" />
    </template>

    <template #menu>
      <navbar-workspaces-menu :close-menu="closeMenuNav" />
    </template>
  </ui-menu>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import NavbarWorkspacesMenu from '@/views/layout/navigation/navbar-workspaces-menu.vue';

const props = withDefaults(
  defineProps<{
    contentClass?: string;
    location?: string;
    offset?: [number, number];
    closeMenu?: () => void;
  }>(),
  {
    contentClass: '',
    location: 'bottom start',
    offset: () => [0, 8],
  },
);

const menu = ref(false);

const closeMenuNav = () => {
  props.closeMenu?.();
  menu.value = false;
};
</script>

<style lang="scss">
.v-overlay__content.main-menu-workspace {
  min-width: 200px !important;
  max-width: 300px !important;
  background: var(--color-white);
  border-radius: 8px !important;
}
</style>

<style lang="scss" scoped>
:deep(.v-menu__activator) {
  height: 100% !important;
}
</style>
